export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/dashed-gray-line.695acd65.svg","height":2,"width":625,"blurWidth":0,"blurHeight":0};